import text from './el-button'
export default text
